import { Minus, Plus } from "@phosphor-icons/react";
import { ArrayFieldTemplateProps } from "@rjsf/utils";
import { useTranslation } from "react-i18next";


function DeliveryNoteFormArrayTemplate(props: ArrayFieldTemplateProps) {
  const { t } = useTranslation();
  const title = props.title || t("delivery_note_lines");
  
  // Verificar si está en modo solo lectura
  const isReadOnly = props.readonly || props.disabled;
  
  return (
    <div className="my-2">
      <div className="d-flex align-items-center justify-content-between">
        <div className="h6 mb-3">{title}</div>
      </div>
      <div>
        {props.items.map((element, index) => {
          return (
            <div className="invoice-line-row d-flex align-items-center">
              <div className="flex-grow-1">{element.children}</div>
              {!isReadOnly && (
                <div className="delete-line d-flex align-items-center">
                  <button
                    type="button"
                    aria-label="remove-line"
                    className="icon-circle icon-circle-danger ms-3"
                    onClick={element.onDropIndexClick(index)}
                  >
                    <Minus size={20} />
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {!isReadOnly && (
        <div className="mt-4 d-flex justify-content-end">
          <div className="add-line">
            {props.canAdd && (
              <button
                type="button"
                aria-label="add-line"
                className="icon-circle icon-circle-primary ms-auto"
                onClick={props.onAddClick}
              >
                <Plus size={20} />
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default DeliveryNoteFormArrayTemplate;
